<template>
    <v-card style="width: 100%;max-height:200px" class="overflow-y-auto rounded-0" >
            <v-data-table :headers="headers" :items="logs" no-data-text="No hay logs por mostrar" class="rounded-0 grey lighten-3 grey--text text--darken-2"  dense hide-default-footer :items-per-page="-1">
                <template v-slot:[`item.fecha`]="{ item }">
                    {{ formatearFecha(item.fecha) }}
                  </template>
                  <template v-slot:[`item.hora`]="{ item }">
                    {{ formatearHora(item.fecha) }}
                  </template>
            </v-data-table>
    </v-card>
</template>

<script>
import {DateTime} from 'luxon';
export default {
    props: {
        logs: {
            type: Array,
            required: true,
        },
    },
    name: 'logsComponent',

    data() {
        return {
            headers: [
                {
                    text: 'Usuario',
                    align: 'center',
                    value: 'usuario.nombreCompleto',
                },
                { text: 'Acción', align: 'center', value: 'accion'},
                { text: 'Fecha', align: 'center', value: 'fecha'},
                { text: 'Hora', align: 'center',value:'hora'},

            ],
        };
    },

    mounted() {
    },

    methods: {
        formatearFecha(fecha) {
            return DateTime.fromISO(fecha).toFormat('dd/MM/yyyy')
        },
        formatearHora(hora){
            return DateTime.fromISO(hora, { zone: 'UTC-0' }).toFormat('HH:mm:ss')
        }
    }
};
</script>

<style lang="scss" scoped></style>